module.exports = __webpack_public_path__ + "img/2.75ecec17.jpg";